import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

import ActionButton from '../../../../Elements/ActionButton/ActionButton';

type HeaderActionProps = {
  isAllowedToEdit: boolean;
  onEdit: (e) => void;
  onCancel: () => void;
  onSave: () => void;
  layout: string;
  isActive?: number;
  disabled?: boolean;
};

const HeaderAction = ({
  isAllowedToEdit,
  onEdit,
  onCancel,
  onSave,
  layout,
  isActive,
  disabled,
}: HeaderActionProps) => {
  return (
    <React.Fragment>
      {isAllowedToEdit && (
        <>
          {layout === 'view' && isActive && (
            <ActionButton
              onClick={onEdit}
              className={clsx(
                'tw-text-cfo-blue-700 !tw-font-brandonTextMedium tw-leading-none',
                '!tw-m-0 !tw-p-0'
              )}
            >
              <Icon icon={ICONS.edit} className={clsx('tw-mr-[7px] tw-text-[20px]')} /> Edit
            </ActionButton>
          )}
          {layout === 'form' && (
            <div className={'tw-flex tw-items-center'}>
              <ActionButton
                className={clsx(
                  '!tw-py-[6px] !tw-px-[10px]',
                  'hover:tw-border-cfo-blue-200 hover:tw-bg-cfo-blue-200 hover:tw-text-cfo-blue-600'
                )}
                onClick={onCancel}
                buttonClassSettings={{
                  variant: 'inverse',
                  size: 'sm',
                  weight: 'bold',
                  position: 'center',
                }}
              >
                Cancel
              </ActionButton>

              <ActionButton
                onClick={onSave}
                className={clsx(
                  '!tw-py-[6px] !tw-px-[10px] !tw-mr-0',
                  'tw-border-cfo-grey-500 tw-rounded-[5px]'
                )}
                buttonClassSettings={{
                  variant: 'secondary',
                  size: 'sm',
                  weight: 'bold',
                  position: 'center',
                  isActive: disabled,
                }}
                disabled={disabled}
              >
                Save
              </ActionButton>
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default HeaderAction;
